import Service from "./Service"

class UserService extends Service {

    search = (queryParams) => this.getWithParams("/users", queryParams)

    getSelectors = () => this.get("/users/selectors")

    getClientSelectors = (queryParams) => this.getWithParams("/users/selectors", queryParams)

    findById = (id) => this.get(`/users/${id}`)

    register = (requestBody, files) => this.uploadFilesWithRequest("/users", "POST", requestBody, files)

    updateUser = (id, requestBody, files) => this.uploadFilesWithRequest(`/users/${id}`, "PATCH", requestBody, files)

    updatePassword = (requestBody) => this.patch("/users/passwords", requestBody)

    deleteUserFile = (id, fileId) => this.del(`/users/${id}/files/${fileId}`)
}

const userService = new UserService()
export default userService